import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
import { Check } from 'lucide-react';
import BrandLogo from '../Brand/BrandLogo';

const AuthBanner = () => {
  const { t } = useLocale();
  const features = [
    t('authBannerFeature1'),
    t('authBannerFeature2'),
    t('authBannerFeature3'),
    t('authBannerFeature4'),
  ];

  return (
    <div className="mesh-gradient-hero-panel relative flex min-h-full flex-1 shrink-0 flex-col gap-12 overflow-hidden rounded-lg px-10 py-16 md:max-w-[670px]">
      <div className="mesh-gradient-hero" aria-hidden />
      <BrandLogo name={t('appName')} to="/" className="relative z-10" />
      <div className="relative z-10 flex flex-col gap-6">
        <h2 className="text-[2.5rem] font-semibold leading-[3rem] tracking-tight text-text-primary">
          {t('authBannerHeadline')}
        </h2>
        <p className="max-w-[532px] text-lg leading-7 text-text-secondary">
          {t('authBannerSubhead')}
        </p>
      </div>
      <div className="relative z-10 flex flex-col gap-3">
        {features.map((label, i) => (
          <div key={i} className="flex items-center gap-2">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-500 text-primary-900">
              <Check className="h-4 w-4" strokeWidth={2.5} aria-hidden />
            </div>
            <span
              className={
                i === 2
                  ? 'text-xl font-semibold text-text-primary'
                  : 'text-xl text-text-secondary'
              }
            >
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default function AuthLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col items-stretch gap-5 bg-background-primary p-4 md:flex-row md:p-10">
      <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-10 overflow-hidden p-4 md:p-10">
        <div className="mx-auto w-full max-w-md rounded-lg border border-border-light bg-background-card p-8 shadow-elevation-4">
          {children}
        </div>
      </div>
      <div className="hidden min-h-[480px] md:flex md:w-[670px] md:shrink-0">
        <AuthBanner />
      </div>
    </div>
  );
}
